import classNames from 'classnames';
import { useState } from 'react';
import styles from './expander.module.scss';
import RichText from '../richtext';

const Expander = ({ data, className }) => {
  const { title, content } = data || {};
  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded(!expanded);
  };

  if (!title?.trim() || !content) return null;

  return (
    <div
      className={classNames(styles.container, className, {
        [styles.expanded]: expanded,
      })}
    >
      {/* eslint-disable-next-line */}
      <div className={styles.title} onClick={handleClick}>
        <span>{title}</span>
        <span className={styles.icon}>{expanded ? '-' : '+'}</span>
      </div>
      <div
        className={classNames(styles.content, {
          [styles.contentHidden]: !expanded,
        })}
      >
        <div className={styles.innerNoScroll}>
          <RichText text={content?.json} className={styles.contentText} />
        </div>
      </div>
    </div>
  );
};

export default Expander;
